import type { LoaderFunctionArgs, MetaFunction } from '@remix-run/node';
import { Link } from '@remix-run/react';
import { useTranslation } from 'react-i18next';
import i18n from '~/i18next.server';
import { createMeta } from '~/lib/create-meta';
import { CenteredPageWrapper } from '~/modules/common/components/centered-page-wrapper/CenteredPageWrapper';
import { CenteredPageHeader } from '~/modules/common/components/centered-page-header/CenteredPageHeader';
import { Button } from '~/modules/theme/components/ui/Button';

const i18nNamespaces = ['common'] as const;

export const handle = {
  i18n: i18nNamespaces,
};

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const t = await i18n.getFixedT(request, i18nNamespaces);
  return {
    meta: createMeta(t, 'common'),
  };
};

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  return [
    { title: data!.meta.title },
    { name: 'description', content: data!.meta.description },
  ];
};

export default function NotFound() {
  const { t } = useTranslation(i18nNamespaces);

  return (
    <CenteredPageWrapper>
      <CenteredPageHeader title={t('common:notFound.title')}>
        <p className="mt-2 text-gray-600">{t('common:notFound.description')}</p>
        <Button asChild variant="secondary" className="mt-4">
          <Link to="/">{t('common:notFound.goHome')}</Link>
        </Button>
      </CenteredPageHeader>
    </CenteredPageWrapper>
  );
}
